// import { turboStreamVisit } from 'common/utils/hotwired/stream_actions';
// Turbo.StreamActions.visit = turboStreamVisit;
// <turbo-stream
//   action="visit"
//   visit-location="/some-resource/1234"
//   visit-frame="someFrameDomId"
//   visit-action="advance|replace"
// ></turbo-stream>
// This is similar to a `window.location = ...` call but invoked with a Turbo
// Stream action. This honors any turbo frame specified. Default action is
// "advance". If no location is given, `window.location`` is used; this has the
// effect of reloading the current location but Turbo-ified.
// See: https://turbo.hotwired.dev/reference/drive#turbo.visit
export function turboStreamVisit() {
  const location = this.getAttribute('visit-location') || window.location.toString();
  Turbo.visit(location, {
    frame: this.getAttribute('visit-frame'),
    action: this.getAttribute('visit-action'),
  });
}

// import { turboStreamDownload } from 'common/utils/hotwired/stream_actions';
// Turbo.StreamActions.download = turboStreamDownload;
// <turbo-stream
//   action="download"
//   download-url="..."
//   download-file-name="..."
//   download-delay-in-ms="..."
// ></turbo-stream>
export function turboStreamDownload() {
  const url = this.getAttribute('download-url');
  const fileName = this.getAttribute('download-file-name');
  const delayInMs = parseInt(this.getAttribute('download-delay-in-ms'), 10) || 1;

  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.setAttribute('download', fileName);
  anchor.style.display = 'none';
  document.body.appendChild(anchor);

  setTimeout(() => {
    anchor.click();
    document.body.removeChild(anchor);
  }, delayInMs);

  return true;
}

// import { turboStreamSetCookie } from 'common/utils/hotwired/stream_actions';
// Turbo.StreamActions.setCookie = turboStreamSetCookie;
// <turbo-stream
//   action="setCookie"
//   cookie-name="my_cookie"
//   cookie-value="myvalue"
//   cookie-domain="example.com"
//   cookie-path="/"
//   cookie-max-age="31536000"
//   cookie-secure="{true|false}"
//   cookie-samesite="{lax|strict|none}"
// ></turbo-stream>
// Set a cookie value based on the given attributes. Name/value are required;
// all other attributes are optional.
export function turboStreamSetCookie() {
  const name = this.getAttribute('cookie-name');
  const value = this.getAttribute('cookie-value');
  const domain = this.getAttribute('cookie-domain');
  const path = this.getAttribute('cookie-path') || '/';
  const maxAge = this.getAttribute('cookie-max-age');
  const secure = this.getAttribute('cookie-secure');
  const samesite = this.getAttribute('cookie-samesite');

  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
  if (domain) {
    cookie += `; domain=${encodeURIComponent(domain)}`;
  }
  if (path) {
    cookie += `; path=${path}`;
  }
  if (maxAge) {
    cookie += `; max-age=${encodeURIComponent(maxAge)}`;
  }
  if (secure === 'true') {
    cookie += '; Secure';
  }
  if (samesite) {
    cookie += `; samesite=${encodeURIComponent(samesite)}`;
  }

  document.cookie = cookie;
}
